import React, { useState, useEffect, useMemo } from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import { getAppTheme, applyCssVars } from './theme';


function Root(){
  const [mode, setMode] = useState(localStorage.getItem('themeMode') || 'light');
  const theme = useMemo(() => getAppTheme(mode), [mode]);

  useEffect(() => {
    applyCssVars(mode);
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <App mode={mode} setMode={setMode} />
    </ThemeProvider>
  );

}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
